// extracted by mini-css-extract-plugin
module.exports = {"container":"SideNav-module__container--1fCWx","topContainer":"SideNav-module__topContainer--2K8vA","navItemsContainer":"SideNav-module__navItemsContainer--3DOdE"};